import { render, staticRenderFns } from "./PriorityTypeChangeActivationType.vue?vue&type=template&id=10056340&"
import script from "./PriorityTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports